import React, { memo, ReactNode } from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';
import ProductAvailabilityIcon from '../product-availability-icon/product-availability-icon';

import styles from './product-availability-message.one-dt.scss';

interface ProductAvailabilityMessageProps {
  availabilityMessage: string;
  availabilityMessageRank?: number;
  className?: string;
  hideIcons?: boolean;
  hideSuffix?: boolean;
  iconAvailable?: ReactNode;
  showBoxDesign?: boolean;
}

function ProductAvailabilityMessage(props: ProductAvailabilityMessageProps) {
  const {
    availabilityMessage,
    availabilityMessageRank,
    className,
    hideIcons = false,
    hideSuffix = false,
    iconAvailable,
    showBoxDesign = false
  } = props;

  const baseMessage = availabilityMessage?.replace(' at My Store', '') || '';
  const parts = baseMessage.split('in stock');
  const hasInStock = parts.length > 1;

  return (
    <Typography
      className={cn(
        styles['container'],
        `${className || ''} product-availability-message`
      )}
      data-testid="product-availability-message"
      tag="span"
    >
      {!hideIcons && (
        <ProductAvailabilityIcon
          availabilityMessageRank={availabilityMessageRank}
          iconAvailable={iconAvailable}
        />
      )}
      <span>
        {hasInStock ? (
          <>
            <span
              className={
                showBoxDesign ? styles['box-design-quantity-text'] : ''
              }
            >
              {parts[0]}
            </span>{' '}
            in stock {parts[1]}
          </>
        ) : (
          baseMessage
        )}
        {!hideSuffix ? ' at ' : ''}
      </span>
    </Typography>
  );
}

export default memo(ProductAvailabilityMessage);
